(function(){
'use strict';

designationsService.$inject = ["$http", "$q"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function designationsService($http, $q) {
  var _this = this;

  var service = {};

  service.createCampaignDesignation = function (campaignId, designationId, data) {
    return $http({
      method: 'POST',
      url: '/frs-api/campaign/' + campaignId + '/designation/' + designationId,
      data: data,
      loadingScope: true
    });
  };

  service.updateCampaignDesignation = function (campaignId, designationId, data) {
    return $http({
      method: 'PUT',
      url: '/frs-api/campaign/' + campaignId + '/designation/' + designationId,
      data: data,
      loadingScope: true
    });
  };

  service.deleteCampaignDesignation = function (campaignId, designationId) {
    return $http({
      method: 'DELETE',
      url: '/frs-api/campaign/' + campaignId + '/designation/' + designationId,
      loadingScope: true
    });
  };

  service.getUnassignedCampaignDesignations = function (campaignId, params) {
    return $http({
      method: 'GET',
      url: '/frs-api/campaigns/' + campaignId + '/unassigned-designations',
      loadingScope: true,
      params: params
    });
  };

  service.getCampaignDesignations = function (campaignId, params) {
    return $http({
      method: 'GET',
      url: '/frs-api/campaigns/' + campaignId + '/designations',
      loadingScope: true,
      params: params
    });
  };

  service.getDesignationGroups = function (campaignId, params) {
    return $http({
      method: 'GET',
      url: '/frs-api/campaigns/' + campaignId + '/groups',
      loadingScope: true,
      params: params
    });
  };

  service.getDesignationsForGroup = function (groupId, params) {
    return $http({
      method: 'GET',
      url: '/frs-api/groups/' + groupId + '/designations',
      loadingScope: true,
      params: params
    });
  };

  service.getGroupedCampaignDesignations = function (campaignId, filters) {
    var groups = [];

    return service.getDesignationGroups(campaignId, { sort: 'sequence:asc' }).then(function (designationGroupsResponse) {
      groups = designationGroupsResponse.data.data;

      return Promise.all(groups.map(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(desingationGroup) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return service.getDesignationsForGroup(desingationGroup.id, filters).then(function (result) {
                    desingationGroup.designations = result.data.data;
                  });

                case 2:
                  return _context.abrupt('return', desingationGroup);

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()));
    });
  };

  service.createDesignationGroup = function (campaignId, data) {
    return $http({
      method: 'POST',
      url: '/frs-api/campaigns/' + campaignId + '/groups',
      loadingScope: true,
      data: data
    });
  };

  service.deleteDesignationGroup = function (groupid) {
    return $http({
      method: 'DELETE',
      url: '/frs-api/groups/' + groupid,
      loadingScope: true
    });
  };

  service.updateDesignationGroup = function (groupid, data) {
    return $http({
      method: 'PUT',
      url: '/frs-api/groups/' + groupid,
      loadingScope: true,
      data: data
    });
  };

  service.getOrganizationDesignations = function (orgId, perPage, page, filter) {
    return $http({
      method: 'GET',
      url: '/frs-api/organizations/' + orgId + '/designations',
      loadingScope: true,
      params: {
        per_page: perPage,
        page: page,
        filter: filter || null
      }
    });
  };

  service.handleBatch = function (campaignId, designations) {
    var numberOfChunks = Math.ceil(designations.length / 50);
    var addDesignationsToChunk = function addDesignationsToChunk(_, i) {
      var start = i * 50;
      var end = start + 50;
      return designations.slice(start, end);
    };
    var chunks = Array(numberOfChunks).fill().map(addDesignationsToChunk);

    return chunks.reduce(function (prev, curr) {
      return prev.then(function () {
        return $http({
          method: 'POST',
          url: '/frs-api/campaign/' + campaignId + '/designation-batch',
          data: {
            designations: curr
          }
        });
      });
    }, $q.resolve());
  };

  service.parseSortOrder = function (designationSortOrder) {
    if (designationSortOrder === 'OLD-NEW') {
      return 'created_at:asc';
    } else if (designationSortOrder === 'NEW-OLD') {
      return 'created_at:desc';
    } else if (designationSortOrder === 'A-Z') {
      return 'name:asc';
    }
    return null;
  };

  return service;
}

angular.module('classy').service('designationsService', designationsService);
})();